import { createAction, props } from '@ngrx/store';
export const setCustomPDFReportStore = createAction('[Custom PDF Report Builder] Set Report Store', props());
